import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';
import moment from 'moment';

class CmsEventHotelStore {
  @observable data = [];
  @observable images = [];

  @observable eventHotels = [];
  @observable eventHotel = null;

  @observable selectedeventHotel = null;
  @observable selectedimages = [];

  @observable showModal = false;
  @observable modalTitle = '';

  @observable updateLoading = false;

  @action getAll() {
    return apiCaller.CmsEventHotels.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getAllByLanguage() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsEventHotels.getActivesByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.eventHotels = resp;
      }
    })
  }

  @action getByIdAndLanguage(id) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsEventHotels.getByIdAndLanguageCode(id, languageCode).then(resp => {
      if (resp) {
        this.selectedeventHotel = resp;
        this.selectedimages = [];
        if (this.selectedeventHotel.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.selectedeventHotel.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.selectedimages = imagesJson;
          } catch {
            this.selectedimages.push({
              id: v4(),
              url: this.selectedeventHotel.bannerUrl,
              isLoading: false
            });
          }
        }
      }
    })
  }

  @action getDataById(id) {
    this.modalTitle = 'Update Hotel Event';
    return apiCaller.CmsEventHotels.getById(id).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.images = [];
          this.eventHotel = resp.data;

          const startDateTime = moment(this.eventHotel.startDate);
          this.eventHotel.startDateObject = startDateTime;
          this.eventHotel.startTimeObject = startDateTime;

          const startEndTime = moment(this.eventHotel.endDate);
          this.eventHotel.endDateObject = startEndTime;
          this.eventHotel.endTimeObject = startEndTime;

          if (this.eventHotel.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.eventHotel.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.images = imagesJson;
            } catch {
              this.images.push({
                id: v4(),
                url: this.eventHotel.bannerUrl,
                isLoading: false
              });
            }
          }

          this.images.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.showModal = true;
        }
      }
    })
  }

  @action initCreate(languages) {
    this.modalTitle = 'Add Hotel Event';

    this.eventHotel = {
      'id': 0,
      'bannerUrl': '',
      'showDate': false,
      'showBannerOnly': false,
      'sort': 1,
      'eventHotelLanguages': []
    };

    const today = moment();
    this.eventHotel.startDateObject = today;
    this.eventHotel.startTimeObject = today;
    this.eventHotel.endDateObject = today;
    this.eventHotel.endTimeObject = today;

    languages.map(language => {
      this.eventHotel.eventHotelLanguages.push({
        'id': 0,
        'eventHotelId': 0,
        'languageId': language.id,
        'title': '',
        'briefDescription': '',
        'description': ''
      });

      return language;
    })

    this.images = [{
      id: v4(),
      url: '',
      isLoading: false
    }];

    this.showModal = true;
  }

  @action create() {
    this.updateLoading = true;

    this.eventHotel.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

    const startTimeObjectFormat = moment(this.eventHotel.startTimeObject).format('HH:mm:00');
    this.eventHotel.startDate = moment(`${moment(this.eventHotel.startDateObject).format('YYYY-MM-DD')} ${startTimeObjectFormat}`);

    const endTimeObjectFormat = moment(this.eventHotel.endTimeObject).format('HH:mm:00');
    this.eventHotel.endDate = moment(`${moment(this.eventHotel.endDateObject).format('YYYY-MM-DD')} ${endTimeObjectFormat}`);

    return apiCaller.CmsEventHotels.create(this.eventHotel);
  }

  @action update() {
    this.updateLoading = true;

    this.eventHotel.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

    const startTimeObjectFormat = moment(this.eventHotel.startTimeObject).format('HH:mm:00');
    this.eventHotel.startDate = moment(`${moment(this.eventHotel.startDateObject).format('YYYY-MM-DD')} ${startTimeObjectFormat}`);
    
    const endTimeObjectFormat = moment(this.eventHotel.endTimeObject).format('HH:mm:00');
    this.eventHotel.endDate = moment(`${moment(this.eventHotel.endDateObject).format('YYYY-MM-DD')} ${endTimeObjectFormat}`);
    
    return apiCaller.CmsEventHotels.update(this.eventHotel.id, this.eventHotel);
  }

  @action delete(id) {
    return apiCaller.CmsEventHotels.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(value) {
    this.eventHotel.sort = value;
  }

  @action setshowBannerOnly(value) {
    this.eventHotel.showBannerOnly = value;
  }

  @action setshowDate(value) {
    this.eventHotel.showDate = value;
  }

  @action setstartDateObject(value) {
    this.eventHotel.startDateObject = value;
  }

  @action setstartTimeObject(value) {
    this.eventHotel.startTimeObject = value;
  }

  @action setendDateObject(value) {
    this.eventHotel.endDateObject = value;
  }

  @action setendTimeObject(value) {
    this.eventHotel.endTimeObject = value;
  }

  @action settitle(langId, value) {
    let lang = this.eventHotel.eventHotelLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.title = value;
    }
  }

  @action setbriefDescription(langId, value) {
    let lang = this.eventHotel.eventHotelLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.briefDescription = value;
    }
  }

  @action setdescription(langId, value) {
    let lang = this.eventHotel.eventHotelLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setImageUrlById(id, value) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.images.find(fi => fi.url === '');
    if (!blankImage) {
      this.images.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setImageIsLoadingById(id, isLoading) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeImageById(id) {
    this.images = this.images.filter(fi => fi.id !== id);
  }

  @action seteventHotel(value) {
    this.eventHotel = value;
  }

  @action setupdateLoading(value) {
    this.updateLoading = value;
  }

  @action setshowModal(value) {
    this.showModal = value
  }

  @action resetData() {
    this.selectedeventHotel = null;
    this.selectedimages = [];
  }
}

export default new CmsEventHotelStore();